import { render, staticRenderFns } from "./GonggaodetailsRight.vue?vue&type=template&id=604e0e62&scoped=true"
import script from "./GonggaodetailsRight.vue?vue&type=script&lang=js"
export * from "./GonggaodetailsRight.vue?vue&type=script&lang=js"
import style0 from "./GonggaodetailsRight.vue?vue&type=style&index=0&id=604e0e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e0e62",
  null
  
)

export default component.exports